import { FC } from 'react';
import { SubUserRow } from '../types';
import GroupCellLayout from './GroupCellLayout';
import { useUserDrawer } from '../../../hooks/useUserDrawer';

type Props = SubUserRow;

const SubUsersTableGroupCell: FC<Props> = ({ groups, primaryUserGuid }) => {
    const { openUserDrawer } = useUserDrawer();

    const handleClick = () => {
        openUserDrawer(primaryUserGuid);
    };

    return <GroupCellLayout groups={groups} onMoreClick={handleClick} />;
};

export default SubUsersTableGroupCell;
